import React from 'react'

import { IconProps } from './types'

const EllipsisIcon = ({ size = 24, ...props }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 13 3'
      height={size}
      width={size}
      {...props}
    >
      <g transform='translate(-1176 -301)'>
        <circle
          fill='currentColor'
          cx='1.5'
          cy='1.5'
          r='1.5'
          transform='translate(1176 301)'
        />
        <circle
          fill='currentColor'
          cx='1.5'
          cy='1.5'
          r='1.5'
          transform='translate(1181 301)'
        />
        <circle
          fill='currentColor'
          cx='1.5'
          cy='1.5'
          r='1.5'
          transform='translate(1186 301)'
        />
      </g>
    </svg>
  )
}

export default EllipsisIcon
